var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content",class:{
    'shift-left': this.$store.state.ui.shiftLeft,
    'shift-right': this.$store.state.ui.shiftRight,
    pt: _vm.mainHeaderVisible && _vm.contentTopPadding
  },on:{"mouseenter":function($event){_vm.mouseOver = true},"mouseleave":function($event){_vm.mouseOver = false}}},[_c('nuxt'),_vm._v(" "),_c('main-footer'),_vm._v(" "),_c('shift-backdrop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }